"use client";

import { useState } from "react";

import { useIsMobile } from "@/hooks/useIsMobile";

import { HomepageHeroImageLifestage, HomepageHeroImageLower } from "./HomepageHeroImage.types";
import HomepageHeroImageBenefits from "./HomepageHeroImageBenefits";
import HomepageHeroImageDesktop from "./HomepageHeroImageDesktop";
import HomepageHeroImageImages from "./HomepageHeroImageImages";
import HomepageHeroImageMobile from "./HomepageHeroImageMobile";

type HomepageHeroImageLowerSectionProps = {
  data: HomepageHeroImageLower;
  isNarrow: boolean;
};

/* Lifestage section under the top hero: pill, tabs and the active lifestage's benefits. */
const HomepageHeroImageLowerSection = ({ data, isNarrow }: HomepageHeroImageLowerSectionProps) => {
  const { benefits, buttons, pill } = data;
  const [active, setActive] = useState<HomepageHeroImageLifestage>("women");

  const benefitsSection = (
    <HomepageHeroImageBenefits items={benefits[active].items} shop={buttons[active]} />
  );

  const imagesSection = <HomepageHeroImageImages pill={pill} />;

  const layout = { data, active, setActive, benefitsSection, imagesSection };
  const isMobile = useIsMobile(1280, isNarrow);

  return (
    <div className="bg-[linear-gradient(to_bottom,#fff_0%,#ecf1f5_100%)] xl:bg-[linear-gradient(to_bottom,#fff_0%,#ecf1f5_30%)]">
      {isMobile ? (
        <HomepageHeroImageMobile {...layout} />
      ) : (
        <HomepageHeroImageDesktop {...layout} />
      )}
    </div>
  );
};

export default HomepageHeroImageLowerSection;
